import { render, staticRenderFns } from "./LineChart.vue?vue&type=template&id=54b436f1&scoped=true&"
import script from "./LineChart.vue?vue&type=script&lang=js&"
export * from "./LineChart.vue?vue&type=script&lang=js&"
import style0 from "./LineChart.vue?vue&type=style&index=0&id=54b436f1&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54b436f1",
  null
  
)

export default component.exports